import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getCustomerByVendor } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';
import { handleCatchError } from 'utils/CatchHandler';

export const useCheckCustomerExist = (search, data) => {
    const navigate = useNavigate();
    const DMT_TYPE = 1;

    const { mutate: checkCustomerExist, isPending: checkExistLoading } = useMutation({
        mutationFn: async () => {
            const payload = { agentId: '2', customerMobileNo: search, dmtType: DMT_TYPE };
            return await getCustomerByVendor(payload);
        },
        onSuccess: (response) => {
            const innerData = response?.data;
            const { ekycStatus } = innerData?.data || {};

            if (ekycStatus) {
                navigate('/moneyTransfer1/moneyTransfer', { state: { search, data, senderno: search } });
            } else if (ekycStatus === false) {
                navigate('/moneyTransfer1/createCustomer', { state: { search, info: data?.note } });
            }
        },
        onError: (error) => {
            handleCatchError(error);
        }
    });

    return { checkCustomerExist, checkExistLoading };
};
